import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/{${apiConstants.code}}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-home" */ `./views/Home.vue`),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `global.manage`,
        }
    },
    {
        path: `/{${apiConstants.code}}/settings`,
        name: `${apiConstants.code}.settings`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-settings" */ './views/settings/DefinitionsDetails.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `settings.titles`,
        }
    },
    {
        path: `/{${apiConstants.code}}/print`,
        name: `${apiConstants.code}.print_visible_emissions`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-print_visible_emissions" */ './views/print/PrintVisibleBase.vue'),
        children: [
            {
                path: 'config',
                name: `${apiConstants.code}.print_visible_emissions.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-print_visible_emissions" */ './views/print/PrintVisibleConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'print_visible_emissions.title',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'print_visible_emissions.title',
        }
    },
    {
        path: `/{${apiConstants.code}}/unities`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-unities" */ './views/unity/UnityBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.unities`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-unities" */ './views/unity/UnityList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `unities.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.unities.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-unities" */ './views/unity/UnityDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `unities.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.unities.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-unities" */ './views/unity/UnityDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `unities.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `unities.titles`,
        }
    },
    {
        path: `/{${apiConstants.code}}/priorities`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-priorities" */ './views/priority/PriorityBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.priorities`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-priorities" */ './views/priority/PriorityList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `priorities.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.priorities.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-priorities" */ './views/priority/PriorityDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `priorities.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.priorities.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-priorities" */ './views/priority/PriorityDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `priorities.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `priorities.titles`,
        }
    },
    {
        path: `/{${apiConstants.code}}/types`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-types" */ './views/type/TypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-types" */ './views/type/TypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `types.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-types" */ './views/type/TypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `types.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-types" */ './views/type/TypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `types.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `types.titles`,
        }
    },
    {
        path: `/{${apiConstants.code}}/subtypes`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-subtypes" */ './views/subtype/SubtypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.subtypes`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-subtypes" */ './views/subtype/SubtypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `subtypes.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.subtypes.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-subtypes" */ './views/subtype/SubtypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `subtypes.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.subtypes.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-subtypes" */ './views/subtype/SubtypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `subtypes.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `subtypes.titles`,
        }
    },
    {
        path: `/{${apiConstants.code}}/channels`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-channels" */ './views/channel/ChannelBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.channels`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-channels" */ './views/channel/ChannelList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `channels.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.channels.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-channels" */ './views/channel/ChannelDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `channels.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.channels.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-channels" */ './views/channel/ChannelDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `channels.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `channels.titles`,
        }
    },
    {
        path: `/{${apiConstants.code}}/status`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-statuses" */ './views/status/StatusBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.statuses`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-statuses" */ './views/status/StatusList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `statuses.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.statuses.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-statuses" */ './views/status/StatusDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `statuses.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.statuses.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-statuses" */ './views/status/StatusDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `statuses.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `statuses.titles`,
        }
    },
    {
        path: `/{${apiConstants.code}}/notifications`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-notifications" */ './views/notification/NotificationBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.notifications`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-notifications" */ './views/notification/NotificationList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `notifications.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.notifications.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-notifications" */ './views/notification/NotificationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `notifications.title`,
                }
            },
            {
                path: 'config',
                name: `${apiConstants.code}.notifications.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-notifications" */ './views/notification/NotificationConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `notifications.titles`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.notifications.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-notifications" */ './views/notification/NotificationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `notifications.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `notifications.titles`,
        }
    },
    {
        path: `/{${apiConstants.code}}/defaultlayers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.default_layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.default_layers.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.default_layers.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `default_layers.titles`,
        }
    },
    {
        path: `/{${apiConstants.code}}/layers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-layers" */ './views/layer/LayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-layers" */ './views/layer/LayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.titles`,
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.layers.create`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-layers" */ './views/layer/LayerDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'resource'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.layers.show.group`,
                props: {isLayer: false},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
            {
                path: 'resource/:id',
                name: `${apiConstants.code}.layers.show.item`,
                props: {isLayer: true},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/regulations`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-regulations" */ "./views/regulation/RegulationBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.regulations`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-regulations" */ "./views/regulation/RegulationList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.titles`
                }
            },
            {
                path: ":type",
                name: `${apiConstants.code}.regulations.create`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-regulations" */ "./views/regulation/RegulationDetails.vue"),
                beforeEnter: (to, from, next) => {
                    let available = ["group", "item"];
                    if (available.indexOf(to.params.type) == -1) {
                        next(false);
                    } else {
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`
                }
            },
            {
                path: "group/:id",
                name: `${apiConstants.code}.regulations.show.group`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-regulations" */ "./views/regulation/RegulationDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`
                }
            },
            {
                path: "item/:id",
                name: `${apiConstants.code}.regulations.show.item`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-regulations" */ "./views/regulation/RegulationDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `regulations.titles`
        }
    },
    {
        path: `/{${apiConstants.code}}/reminders`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-reminders" */ './views/reminder/ReminderBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.reminders`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-reminders" */ './views/reminder/ReminderList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `reminders.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.reminders.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-reminders" */ './views/reminder/ReminderDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `reminders.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.reminders.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-reminders" */ './views/reminder/ReminderDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `reminders.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `reminders.titles`,
        }
    },
    {
        path: `/{${apiConstants.code}}/edoclink`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-edoclink_maps" */ './views/edoclink/EdoclinkMapBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.edoclink_maps`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-edoclink_maps" */ './views/edoclink/EdoclinkMapList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `edoclink_maps.titles`,
                }
            },
            {
                path: 'config',
                name: `${apiConstants.code}.edoclink_maps.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-edoclink_maps" */ './views/edoclink/EdoclinkMapConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `edoclink_maps.title`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.edoclink_maps.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-edoclink_maps" */ './views/edoclink/EdoclinkMapDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `edoclink_maps.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.edoclink_maps.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "mbgestao-edoclink_maps" */ './views/edoclink/EdoclinkMapDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `edoclink_maps.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `edoclink_maps.titles`,
        }
    },
];

export default routes;